import React from 'react';
import { InfoIcon } from 'lucide-react';
interface HeaderProps {
  showVat: boolean;
  setShowVat: (show: boolean) => void;
}
export function Header({
  showVat,
  setShowVat
}: HeaderProps) {
  return <header className="pt-6 pb-4" data-id="element-111">
      <div className="flex flex-col space-y-4" data-id="element-112">
        {/* Title */}
        <div data-id="element-113">
          <h1 className="text-2xl font-medium text-gray-900" data-id="element-114">
            Roth Open Configurator – Mix & Match (HVAC)
          </h1>
        </div>
        {/* Project info chips */}
        <div className="flex flex-wrap gap-2 mt-2" data-id="element-115">
          <div className="bg-white px-3 py-1.5 rounded-full text-sm text-gray-700 shadow-sm border border-gray-200" data-id="element-116">
            Villa 180 m² • 2 etager
          </div>
          <div className="bg-white px-3 py-1.5 rounded-full text-sm text-gray-700 shadow-sm border border-gray-200" data-id="element-117">
            Strandvejen 42, 2900 Hellerup
          </div>
          <div className="bg-white px-3 py-1.5 rounded-full text-sm text-gray-700 shadow-sm border border-gray-200" data-id="element-118">
            Kontakt: Lars Jensen
          </div>
          <div className="bg-white px-3 py-1.5 rounded-full text-sm text-gray-700 shadow-sm border border-gray-200" data-id="element-119">
            Gyldig til: 15. december 2023
          </div>
        </div>
        {/* Toggle and co-branding */}
        <div className="flex flex-wrap justify-between items-center mt-2" data-id="element-120">
          <div className="flex items-center" data-id="element-121">
            <label htmlFor="vat-toggle" className="mr-2 text-sm text-gray-700" data-id="element-122">
              {showVat ? 'Vis inkl. moms' : 'Vis ekskl. moms'}
            </label>
            <div className="relative inline-block w-12 h-6 transition duration-200 ease-in-out rounded-full" data-id="element-123">
              <input id="vat-toggle" type="checkbox" className="absolute w-6 h-6 opacity-0 cursor-pointer z-10" checked={showVat} onChange={() => setShowVat(!showVat)} data-id="element-124" />
              <div className={`w-12 h-6 rounded-full transition-colors ${showVat ? 'bg-red-500' : 'bg-gray-300'}`} data-id="element-125"></div>
              <div className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform ${showVat ? 'transform translate-x-6' : ''}`} data-id="element-126"></div>
            </div>
          </div>
          <div className="text-sm text-gray-500 flex items-center" data-id="element-127">
            Powered by Roth – understøtter tredjepartsprodukter
          </div>
        </div>
        {/* Micro note */}
        <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-128">
          <InfoIcon className="h-3.5 w-3.5 mr-1" data-id="element-129" />
          <span data-id="element-130">
            One-pager: rul for at konfigurere, se pris/TCO og acceptere.
          </span>
        </div>
      </div>
    </header>;
}